export async function apiFetch(url, options = {}) {
  const token = localStorage.getItem('token');

  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  const mergedHeaders = {
    ...defaultHeaders,
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const response = await fetch(url, {
    ...options,
    headers: mergedHeaders,
  });

  if (response.status === 401) {
    try { localStorage.removeItem('token'); } catch (_) {}
    // Soft-redirect to unauthorized page
    if (typeof window !== 'undefined') {
      const current = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/unauthorized?from=${current}`;
    }
  }

  return response;
}


